const formatPhoneNumber = (phone) => phone.replace(/\D/g, '');

export const createOrderRequest = (newStore) => {
  const typeOfCargoId = newStore.cargoInformation.typeOfCargo.id;
  let dimensions = {};

  if (typeOfCargoId === 1) {
    dimensions = {
      length: Number(newStore.cargoInformation.cargoDimensions.length),
      width: Number(newStore.cargoInformation.cargoDimensions.width),
      height: Number(newStore.cargoInformation.cargoDimensions.height),
    };
  } else if (typeOfCargoId === 2) {
    dimensions = {
      diameter: Number(newStore.cargoInformation.sizeOfCargoCylinder.diameter),
      height: Number(newStore.cargoInformation.sizeOfCargoCylinder.height),
    };
  }

  let cargoPickUpInfo = {};

  if (newStore.sender.senderZaborType === 'Забор груза') {
    cargoPickUpInfo = {
      pickUpDetails: {
        address: newStore.sender.addressCargoPickup ? newStore.sender.addressCargoPickup.value : null,
        details: newStore.sender.detailsPickup || null,
        longitude: newStore.sender.addressCargoPickup.data.geo_lon ? parseFloat(newStore.sender.addressCargoPickup.data.geo_lon) : null,
        latitude: newStore.sender.addressCargoPickup.data.geo_lat ? parseFloat(newStore.sender.addressCargoPickup.data.geo_lat) : null,
        period: newStore.sender.cargoTimePickup,
        payer: newStore.sender.whoPaysZabor === 'Отправитель' ? 1 : newStore.sender.whoPaysZabor === 'Получатель' ? 2 : 3,

        paymentType: newStore.sender.typeOfPaymentZabor === 'Наличные' ? 1 : 2,
        comment: newStore.sender.comment,
        powerOfAttorney: newStore.sender.powerOfAttorney,
        powerOfAttorneyType: newStore.sender.typePowerOfAttorney,
        sendDriverDetails: newStore.sender.dataForTheDriver,
      },
    };
  } else {
    cargoPickUpInfo = {
      officeAddress: newStore.sender.addressCargoPickup,
    };
  }

  let cargoDeliveryInfo = {};

  if (newStore.consignee.consigneeDeliveryType === 'Доставка до адреса') {
    cargoDeliveryInfo = {
      deliveryDetails: {
        address: newStore.consignee.addressCargoDelivery ? newStore.consignee.addressCargoDelivery.value : null,
        details: newStore.consignee.detailsDelivery || null,
        longitude: newStore.consignee.addressCargoDelivery.data.geo_lon ? parseFloat(newStore.consignee.addressCargoDelivery.data.geo_lon) : null,
        latitude: newStore.consignee.addressCargoDelivery.data.geo_lat ? parseFloat(newStore.consignee.addressCargoDelivery.data.geo_lat) : null,
        period: newStore.consignee.cargoTimeDelivery,
        payer: newStore.consignee.whoPaysCargoDelivery === 'Отправитель' ? 1 : newStore.consignee.whoPaysCargoDelivery === 'Получатель' ? 2 : 3,

        paymentType: newStore.consignee.typeOfPaymentCargoDelivery === 'Наличные' ? 1 : 2,
      },
    };
  } else {
    cargoDeliveryInfo = {
      officeAddress: newStore.consignee.addressCargoDelivery,
    };
  }

  // Номера только цифры

  return {
    customer: {
      clientType: newStore.thirdPerson.typeThirdPerson ? 2 : 1,
      phone: formatPhoneNumber(newStore.thirdPerson.phoneThirdPerson),
      email: newStore.thirdPerson.emailThirdPerson || null,
      title: newStore.thirdPerson.typeThirdPerson ? newStore.thirdPerson.name : newStore.thirdPerson.fioThirdPerson,
      inn: newStore.thirdPerson.typeThirdPerson ? newStore.thirdPerson.innThirdPerson : null,
    },

    payer: newStore.thirdPerson.whoPaysCargoTransportation === 'Отправитель' ? 1 : newStore.thirdPerson.whoPaysCargoTransportation === 'Получатель' ? 2 : 3,
    paymentType: newStore.thirdPerson.typeOfPaymentCargoTransportation === 'Наличные' ? 1 : 2,

    cargo: {
      cargoType: newStore.cargoInformation.typeOfCargo.id,
      cargoNature: newStore.cargoInformation.natureOfCargo,
      cargoCount: Number(newStore.cargoInformation.numberOfIdenticalLoads),
      declaredValue: Number(newStore.cargoInformation.cargoCost),
      weight: Number(newStore.cargoInformation.cargoWeight) || null,
      ...dimensions,
      selectedPackaging: newStore.cargoInformation.typeOfPackaging,
    },
    additionalServices: {
      cashOnDelivery: newStore.cargoInformation.cashOnDelivery
        ? {
            value: Number(newStore.cargoInformation.cashOnDeliverySum),
          }
        : null,
      cargoRepurchase: newStore.cargoInformation.cargoRedemption
        ? {
            payer: Number(newStore.cargoInformation.whoPaysTheRansom) + 1,
            value: Number(newStore.cargoInformation.cargoRedemptionSum),
          }
        : null,
      returnDocuments: newStore.cargoInformation.returnOfDocuments,
    },

    sender: {
      clientType: newStore.sender.senderType ? 2 : 1,
      phone: formatPhoneNumber(newStore.sender.phoneSender),
      email: newStore.sender.emailSender || null,
      title: newStore.sender.senderType ? newStore.sender.name : newStore.sender.fioSender,
      inn: newStore.sender.senderType ? newStore.sender.innSender : null,
    },
    cityFrom: newStore.sender.cityFrom,
    cargoPickUpInfo,

    consignee: {
      clientType: newStore.consignee.consigneeType ? 2 : 1,
      phone: formatPhoneNumber(newStore.consignee.phoneConsignee),
      email: newStore.consignee.emailConsignee || null,
      title: newStore.consignee.consigneeType ? newStore.consignee.name : newStore.consignee.fioConsignee,
      inn: newStore.consignee.consigneeType ? newStore.consignee.innConsignee : null,
    },
    cityTo: newStore.consignee.cityTo,

    cargoDeliveryInfo,
  };
};
